import React from 'react';
import debounce from 'lodash/debounce';

interface WithDebounceState {
  debounced?: Function;
}

export const withDebounce = <P extends any>(
  WrappedComponent: React.ComponentType<P>,
  debouncedProp: FunctionPropertyNames<P>,
  debounceTime: number = 300,
) =>
  class extends React.Component<P, WithDebounceState> {
    readonly state: Readonly<WithDebounceState> = {};

    constructor(props, context) {
      super(props, context);
      if (props[debouncedProp]) {
        this.state = {
          debounced: debounce(props[debouncedProp] as any, debounceTime),
        };
      }
    }

    componentDidUpdate(prevProps: P) {
      if (
        prevProps[debouncedProp] !== this.props[debouncedProp] &&
        this.props[debouncedProp]
      ) {
        this.setState({
          debounced: debounce(this.props[debouncedProp] as any, debounceTime),
        });
      }
    }

    render() {
      const newProps = { ...(this.props as any) };
      const { debounced } = this.state;

      if (debounced) {
        newProps[debouncedProp] = debounced;
      }

      return <WrappedComponent {...newProps} />;
    }
  };
